<script setup>
import { DmFile, DmFileUpload, ErrorHighlighter, TabButton, TabContent, Tabs, UriInput } from 'dmui_components'
import { ref } from 'vue'

const props = defineProps({
	fileData: {
		type: Object,
		default: () => ({})
	},
	url: {
		type: String,
		default: undefined
	},
	readOnly: {
		type: Boolean,
		default: false
	},
	errors: {
		type: Object,
		default: undefined
	}
})
const emit = defineEmits(['update:url', 'update:fileData'])

const uploadError = ref(undefined)

class CustomFileReader {
	readFile(file) {
		return { file, filename: file.name }
	}
}

function _onFileUpload(fileContents) {
	emit('update:fileData', { file: fileContents.file, filename: fileContents.filename })
	emit('update:url', undefined)
}

function _onDownloadReport() {
	window.open(props.fileData?.download_link)
}

function _onUpdateUrl(url) {
	emit('update:url', url)
	emit('update:fileData', { file: undefined, filename: undefined, download_link: undefined })
}
</script>

<template>
	<Tabs default="use-url" tab-type="secondary">
		<template #buttons>
			<TabButton name="use-url">URL</TabButton>
			<TabButton name="upload-file">Upload file</TabButton>
		</template>
		<TabContent name="use-url">
			<ErrorHighlighter :errors="errors?.document_url">
				<UriInput id="url-input" placeholder="Enter URL" :data="url" :read-only="readOnly" @update:data="_onUpdateUrl" />
			</ErrorHighlighter>
		</TabContent>
		<TabContent name="upload-file">
			<DmFile
				id="report-upload"
				:filename="fileData.filename"
				:error="uploadError || errors?.file?.[0]?.message"
				:show-delete="false"
				:show-download="!!fileData.download_link"
				@download="_onDownloadReport">
				<DmFileUpload id="report-upload-btn" accept="application/pdf" :reader="new CustomFileReader()" @update:data="_onFileUpload" @update:error="uploadError = $event" />
			</DmFile>
		</TabContent>
	</Tabs>
</template>

<style scoped lang="less">
:deep(.tab-content) {
	padding-top: @midi;
	&#tab-content-upload-file {
		padding-bottom: 19px; //for consistency with error-highlighter
	}
}
:deep(.fileinfo-tile) {
	width: 100%;
	max-width: none;
	box-sizing: border-box;
}
</style>
